export const SAVE_USER = 'SAVE_USER'
export const SAVE_DETAILS = 'SAVE_DETAILS'
